module.exports = __webpack_public_path__ + "static/img/loan3.510326af.png";